import { GameVars } from "../../../GameVars";
import { GameType } from "../../../Types";
import type { GameOverMenuConfig } from "./GameOverMenu";

export class GameOverScore extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, public readonly config: GameOverMenuConfig) {

        super(scene);

        const chicago = config.gameType === GameType.CHICAGO;
        this.setSize(chicago ? 532 : 552, 88);
        const title = this.createLabel(0, chicago ? "TOTAL SCORE" : "GAMES WON", chicago ? 24 : 28, "#B8DEF4");
        this.add(title);

        for (const [index, partnership] of (["northSouth", "eastWest"] as const).entries()) {
            const won = partnership === config.winningPartnership;
            const x = chicago ? 178 : 188;
            const score = new Phaser.GameObjects.Container(scene, index === 0 ? -x : x, 0);
            const shadow = new Phaser.GameObjects.Graphics(scene);
            shadow.fillStyle(0x000000, .35).fillRoundedRect(-88, -38, 176, 84, 18);
            const background = new Phaser.GameObjects.Graphics(scene);
            background.fillStyle(won ? 0x007338 : 0x06335b, 1).fillRoundedRect(-88, -42, 176, 84, 18);
            background.lineStyle(3, won ? 0x45ee75 : 0x37b0ff, 1);
            background.strokeRoundedRect(-88, -42, 176, 84, 18);
            const points = config.scores[partnership];
            const value = this.createLabel(
                chicago ? 15 : -2,
                GameVars.formatNumber(chicago ? points.totalPoints : points.gamesWon),
                chicago ? 48 : 64, won ? "#FFDA72" : "#FFFFFF"
            );
            value.setScale(Math.min(1, 152 / value.width), 1);
            score.add([shadow, background, value]);
            if (chicago) {
                score.add(this.createLabel(-23, index === 0 ? "N - S" : "E - W", 22, "#FFFFFF"));
            }
            this.add(score);
        }
    }

    private createLabel(y: number, text: string, fontSize: number, color: string): Phaser.GameObjects.Text {

        return new Phaser.GameObjects.Text(this.scene, 0, y, text, {
            fontFamily: "Baloo2-Bold", fontSize: `${fontSize}px`, color,
            stroke: "#00152E", strokeThickness: 2
        }).setOrigin(.5).setShadow(0, 3, "#00152E", 3, false, true);
    }
}
